<template>
  <v-container style="height:100%">
    <v-row align="end" no-gutters style="height:70%">
      <v-col class="d-flex justify-center mb-6">
        <vue-typed-js
          :loop="true"
          :typeSpeed="200"
          :strings="['Full Stack Developer', 'Cloud Engineer', 'Digital Entrepreneur']"
        >
          <h1 class="white--text">
            <span class="typing"></span>
          </h1>
        </vue-typed-js>
      </v-col>
    </v-row>
    <v-row align="start" no-gutters style="height:30%" class="d-flex justify-center">
      <!-- bonus: styling needs to be lg=2, md=auto, lg=2 -->
      <v-col v-for="(item, index) in socialMedia" :key="index" lg="2">
        <a id="link" target="_blank" :href="item.link">
          <v-btn :ripple="false" fab dark :color="item.iconColor">
            <v-icon large dark>{{ item.icon }}</v-icon>
          </v-btn>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "FirstBackground",
  data: () => ({
    socialMedia: [
      {
        link: "https://github.com/edreinoso",
        iconColor: "#323031",
        icon: "mdi-github"
      },
      {
        link: "https://www.linkedin.com/in/edgardo-reinoso-135683108/",
        iconColor: "#007AB9",
        icon: "mdi-linkedin"
      },
      {
        link: "https://twitter.com/EReinoso23",
        iconColor: "#55ACEE",
        icon: "mdi-twitter"
      }
    ]
  })
};
</script>

<style>
</style>